import CourseInterface from './../interface/CourseInterface';
import CurrencyInterface from './../interface/CurrencyInterface';
import CityInterface from './../interface/CityInterface';
import EventInterface from './../interface/EventInterface';

export default class CourseOrder {
    app: any;
    allowChangeQuantity: boolean;
    bookingReference: string | null;
    course: CourseInterface;
    coupon: any;
    city: CityInterface;
    currency: CurrencyInterface;
    events: any[];
    id: string;
    quantity: number;
    price: number;
    priceDiscounted: number;
    type: string;
    isLastMinute: boolean;

    constructor(
        app: any,
        id: string,
        city: CityInterface,
        type: string,
        course: CourseInterface,
        quantity: number,
        price: number,
        coupon: any,
        priceDiscounted: number,
        currency: CurrencyInterface,
        allowChangeQuantity: boolean,
        bookingReference: string | null,
        events: any[],
        isLastMinute: boolean = false
    ) {
        this.app = app;
        this.bookingReference = bookingReference;
        this.currency = currency;
        this.coupon = coupon;
        this.city = city;
        this.id = id;
        this.allowChangeQuantity = allowChangeQuantity;
        this.course = course;
        this.quantity = quantity;
        this.price = price;
        this.priceDiscounted = priceDiscounted;
        this.type = type;
        this.events = events;
        this.isLastMinute = isLastMinute;
    }

    title(): string {
        return (
            this.course.name ||
            this.app.locale.trans('user.cart.product.title.' + this.course.type)
        );
    }

    getBadge(): string | null {
        // Returns a translation string.
        return this.course.type === 'pack' ? 'course.pack.label' : null;
    }

    calcPriceDiscounted(): number {
        return this.priceDiscounted * this.quantity;
    }

    calcPrice(): number {
        return this.price * this.quantity;
    }

    isPast(): boolean {
        if (!this.events || !this.events.length) {
            return true;
        }

        return this.events.some(
            (event) =>
                event && this.app.lib.moment(event.start_datetime).isBefore()
        );
    }

    isTooSoon(): boolean {
        let firstEvent = this.getFirstEvent();

        if (!firstEvent) {
            return false;
        }

        let daysBeforeCourse = this.app.lib
            .moment(firstEvent.start_datetime)
            .diff(this.app.lib.moment(), 'days');

        return daysBeforeCourse <= 9;
    }

    isCancelled(): boolean {
        let firstEvent = this.getFirstEvent();
        return firstEvent && firstEvent.is_cancelled;
    }

    /**
     * Course type has always one single event.
     * Pack type is a collection of course having one single event.
     * When ordered, each cours of a pack is displayed as a single course.
     */
    getFirstEvent(): EventInterface {
        return this.events[0];
    }
}
